import React from 'react'

export const AdminContext = React.createContext(false)
export const EditContext = React.createContext(false)
export const ShowErrorContext = React.createContext(false)
export const RegisterContext = React.createContext({})
export const EventContext = React.createContext({})
export const ErrorContext = React.createContext({})
export const EventFormContext = React.createContext({})
export const ContactFormContext = React.createContext({})
